"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectMiningGuildBonus = void 0;
var DeferredAction_1 = require("./DeferredAction");
var OrOptions_1 = require("../inputs/OrOptions");
var SelectOption_1 = require("../inputs/SelectOption");
var Resources_1 = require("../Resources");
var SelectMiningGuildBonus = (function () {
    function SelectMiningGuildBonus(player, title) {
        if (title === void 0) { title = 'Select Mining Guild bonus'; }
        this.player = player;
        this.title = title;
        this.priority = DeferredAction_1.Priority.SELECT_MINING_GUILD_BONUS;
    }
    SelectMiningGuildBonus.prototype.execute = function () {
        var _this = this;
        var option = new OrOptions_1.OrOptions(new SelectOption_1.SelectOption('Gain titanium production', 'Select', function () {
            _this.player.addProduction(Resources_1.Resources.TITANIUM, 1);
            return undefined;
        }), new SelectOption_1.SelectOption('Gain steel production', 'Select', function () {
            _this.player.addProduction(Resources_1.Resources.STEEL, 1);
            return undefined;
        }));
        option.title = this.title;
        return option;
    };
    return SelectMiningGuildBonus;
}());
exports.SelectMiningGuildBonus = SelectMiningGuildBonus;
//# sourceMappingURL=SelectMiningGuildBonus.js.map